export const MEETING_STATUS = {
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    PENDING: 'pending',
    DONE: 'done'
};

export const RESERVED_STATUS = {
    AVAILABLE: 'AVAILABLE',
    NOTAVAILABLE: 'NOTAVAILABLE',
    RESERVED: 'RESERVED'
};

export const CTA_TYPE = {
    NOTIFY: 'notify',
    RESERVE: 'reserve',
    TEST_DRIVE: 'testDrive',
    INTERESTED: 'interested',
    GET_STARTED: 'getStarted',
    REQUEST_CALL: 'requestCallBack',
    STORE_VISIT: 'storeVisit'
};

export const MEETING_TYPE = {
    // Todo: map all type values for HOME TEST DRIVE
    HOME: '',
    STORE: 'meeting_c2b',
    STORE_VISIT: 'meeting_store_visit'
};

export const USER = 'user';
export const ITEM = 'item';

export const INTENT_CTA_MAP = [CTA_TYPE.RESERVE, CTA_TYPE.TEST_DRIVE, CTA_TYPE.STORE_VISIT, CTA_TYPE.INTERESTED, CTA_TYPE.REQUEST_CALL];
